import request from '../http'

/**
 * 打印相关API
 */

/**
 * 获取固定价结算单打印数据
 * @param {number} settlementId - 结算单ID
 * @returns {Promise} API响应
 */
export function getFixedPriceSettlementPrintData(settlementId) {
  return request({
    url: `/print/settlement/fixed-price/${settlementId}`,
    method: 'get'
  })
}

/**
 * 获取变动价结算单打印数据（预留接口）
 * @param {number} settlementId - 结算单ID
 * @returns {Promise} API响应
 */
export function getFloatingPriceSettlementPrintData(settlementId) {
  return request({
    url: `/print/settlement/floating-price/${settlementId}`,
    method: 'get'
  })
}

/**
 * 获取合同打印数据（预留接口）
 * @param {number} contractId - 合同ID
 * @returns {Promise} API响应
 */
export function getContractPrintData(contractId) {
  return request({
    url: `/print/contract/${contractId}`,
    method: 'get'
  })
}

/**
 * 获取订单打印数据（预留接口）
 * @param {number} orderId - 订单ID
 * @returns {Promise} API响应
 */
export function getOrderPrintData(orderId) {
  return request({
    url: `/print/order/${orderId}`,
    method: 'get'
  })
}

/**
 * 获取发票打印数据（预留接口）
 * @param {number} invoiceId - 发票ID
 * @returns {Promise} API响应
 */
export function getInvoicePrintData(invoiceId) {
  return request({
    url: `/print/invoice/${invoiceId}`,
    method: 'get'
  })
}

/**
 * 获取利息计算打印数据
 * @param {number} recordId - 利息计算ID
 * @returns {Promise} API响应，包含结算明细及四类签名图片URL
 */
export function getInterestCalculationPrintData(recordId) {
  return request({
    url: `/print/interest-calculation/${recordId}`,
    method: 'get'
  })
}

export function registerPrintRecord(documentType, documentKey) {
  return request({
    url: '/print/records',
    method: 'post',
    data: {
      documentType,
      documentKey
    }
  })
}
